export default "__VITE_ASSET__ChsiC_bu__"